import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { COMPANY } from "../data/mock";

const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(
  COMPANY.address.full
)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  COMPANY.address.full
)}`;

const LocationMap = () => {
  return (
    <section id="location" className="py-24 bg-[#fbfafc]">
      <div className="aaa-container">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="aaa-eyebrow mb-3">Visit Us</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold">Our Location</h2>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-stretch">
          <div className="lg:col-span-2 bg-white rounded-2xl p-9 flex flex-col justify-center"
            style={{ boxShadow: "0 18px 50px -28px rgba(61,59,84,0.28)" }}>
            <div className="w-14 h-14 rounded-xl aaa-hero-gradient flex items-center justify-center mb-6">
              <MapPin size={26} className="text-white" />
            </div>
            <h3 className="font-display text-2xl font-bold mb-3">{COMPANY.shortName}</h3>
            <p className="text-[#4a4860] text-lg leading-relaxed">
              {COMPANY.address.line1}
              <br />
              {COMPANY.address.line2}
            </p>
            <a
              href={directionsHref}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-7 self-start aaa-btn-primary px-6 py-3 rounded-md font-medium inline-flex items-center gap-2"
            >
              <Navigation size={18} /> Get Directions
            </a>
          </div>

          <div className="lg:col-span-3 rounded-2xl overflow-hidden min-h-[360px]"
            style={{ boxShadow: "0 18px 50px -28px rgba(61,59,84,0.28)" }}>
            <iframe
              title="AAA Computers location map"
              src={mapSrc}
              className="w-full h-full min-h-[360px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationMap;
